import React, { useEffect, useState, useMemo } from "react";
import { Tabs, Tab, Spinner, Container, Row, Col } from "react-bootstrap";
import { Scatter } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  CategoryScale,
} from "chart.js";
import "./StateNegotations.css";
import { getNegotiations } from "../../services/graphicsService";
ChartJS.register(LinearScale, PointElement, Tooltip, Legend, CategoryScale);

export const StateNegotations = () => {
  const [selectedTab, setSelectedTab] = useState("1d");
  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState({});
  
  const generarData1M = () => {
    const dias = Array.from({ length: 30 }, (_, i) => `Día ${i + 1}`);
    const negociaciones = {};

    dias.forEach((dia) => {
      // Entre 3 y 10 puntos por día
      const puntosPorDia = Math.floor(Math.random() * 8) + 3;
      negociaciones[dia] = Array.from({ length: puntosPorDia }, () => ({
        ofertaCompra: 10000 + Math.floor(Math.random() * 6000),
        ofertaVenta: 14000 + Math.floor(Math.random() * 6000),
        cierre: 12000 + Math.floor(Math.random() * 6000),
      }));
    });

    return { xLabels: dias, negociaciones };
  };

  const dataFalsa = {
    "1d": {
      xLabels: [
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
      ],
      negociaciones: {
        "09:00": [
          { ofertaCompra: 12000, ofertaVenta: 15000, cierre: 13000 },
          { ofertaCompra: 11000, ofertaVenta: 15500, cierre: 13500 },
        ],
        "10:00": [
          { ofertaCompra: 10000, ofertaVenta: 14000, cierre: 13200 },
          { ofertaCompra: 11500, ofertaVenta: 14500, cierre: 13600 },
        ],
        "11:00": [{ ofertaCompra: 12500, ofertaVenta: 14200, cierre: 13800 }],
        "12:00": [{ ofertaCompra: 10500, ofertaVenta: 14800, cierre: 13400 }],
        "13:00": [{ ofertaCompra: 12000, ofertaVenta: 14900, cierre: 13700 }],
        "14:00": [{ ofertaCompra: 11000, ofertaVenta: 15000, cierre: 13300 }],
        "15:00": [{ ofertaCompra: 10800, ofertaVenta: 15100, cierre: 13900 }],
        "16:00": [{ ofertaCompra: 11800, ofertaVenta: 14700, cierre: 13600 }],
        "17:00": [{ ofertaCompra: 11200, ofertaVenta: 15200, cierre: 13400 }],
        "18:00": [{ ofertaCompra: 10900, ofertaVenta: 15300, cierre: 13100 }],
        "19:00": [{ ofertaCompra: 11300, ofertaVenta: 15400, cierre: 13500 }],
      },
    },
    "3d": {
      xLabels: ["Día 1", "Día 2", "Día 3"],
      negociaciones: {
        "Día 1": [
          { ofertaCompra: 12000, ofertaVenta: 16000, cierre: 14000 },
          { ofertaCompra: 13000, ofertaVenta: 15500, cierre: 14500 },
        ],
        "Día 2": [
          { ofertaCompra: 14000, ofertaVenta: 16500, cierre: 15000 },
          { ofertaCompra: 13500, ofertaVenta: 16200, cierre: 14800 },
        ],
        "Día 3": [{ ofertaCompra: 15000, ofertaVenta: 17000, cierre: 15500 }],
      },
    },
    "1w": {
      xLabels: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
      negociaciones: {
        Lun: [{ ofertaCompra: 13000, ofertaVenta: 16000, cierre: 14500 }],
        Mar: [{ ofertaCompra: 14000, ofertaVenta: 16500, cierre: 15000 }],
        Mié: [{ ofertaCompra: 13500, ofertaVenta: 15500, cierre: 14500 }],
        Jue: [{ ofertaCompra: 13800, ofertaVenta: 16200, cierre: 14800 }],
        Vie: [{ ofertaCompra: 14500, ofertaVenta: 16800, cierre: 15200 }],
        Sáb: [{ ofertaCompra: 14200, ofertaVenta: 16600, cierre: 15100 }],
        Dom: [{ ofertaCompra: 15000, ofertaVenta: 17000, cierre: 15500 }],
      },
    },
    "1m": generarData1M(),
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setChartData(dataFalsa[selectedTab]); // ← Ahora cambia según el tab
      setLoading(false);
    }, 500);
  }, [selectedTab]);

  const handleTabChange = (tab) => setSelectedTab(tab);

  const { buyOffers, sellOffers, openOffers } = useMemo(() => {
    if (!chartData?.negociaciones)
      return { buyOffers: [], sellOffers: [], openOffers: [] };

    const buys = [];
    const sells = [];
    const opens = [];

    Object.keys(chartData.negociaciones).forEach((hora, index) => {
      chartData.negociaciones[hora].forEach((n) => {
        buys.push({ x: hora, y: n.ofertaCompra });
        sells.push({ x: hora, y: n.ofertaVenta });
        opens.push({ x: hora, y: n.cierre });
      });
    });

    return { buyOffers: buys, sellOffers: sells, openOffers: opens };
  }, [chartData]);

  const data = {
    datasets: [
      {
        label: "Transacción cerrada",
        data: buyOffers,
        borderColor: "rgb(101 91 154)",
        backgroundColor: "rgb(101 91 154)",
        pointStyle: "cross",
        pointRadius: 8,
        showLine: false,
      },
      {
        label: "Orden vencida",
        data: sellOffers,
        borderColor: "#FDAE9F",
        backgroundColor: "#FDAE9F",
        pointStyle: "circle",
        pointRadius: 8,
        showLine: false,
      },
      {
        label: "Orden abierta",
        data: openOffers,
        borderColor: "rgb(203 230 97)",
        backgroundColor: "white",
        pointStyle: "circle",
        pointRadius: 8,
        showLine: false,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
    },
    scales: {
      x: {
        type: "category",
        title: { display: true, text: "Hora" },
      },
      y: {
        title: { display: true, text: "Precio de la Oferta (COP)" },
        ticks: {
          stepSize: 300,
        },
      },
    },
  };

  return (
    <Container>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <Row className="justify-content-center mt-4">
            <Col xs="auto" className="state-negotations-tabs">
              <Tabs
                activeKey={selectedTab}
                onSelect={handleTabChange}
                className="mb-3"
              >
                <Tab eventKey="1d" title="1D" />
                <Tab eventKey="3d" title="3D" />
                <Tab eventKey="1w" title="1S" />
                <Tab eventKey="1m" title="1M" />
              </Tabs>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={10} className="mx-auto">
              <div className="chart-container">
                <Scatter
                  data={data}
                  options={{
                    ...options,
                    responsive: true,
                    maintainAspectRatio: false,
                  }}
                />
              </div>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};
